import { SelectInput } from '@ktag/styleguide/dist/react';
import ApiContext from 'api/ApiContext';
import { CountingCirclesRecord } from 'api/api.types';
import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  records: CountingCirclesRecord[];
  selectedMapElement: CountingCirclesRecord | null;
  setSelectedMapElement: (element: CountingCirclesRecord | null) => void;
}

const ProportionalMapSelect = ({
  records,
  selectedMapElement,
  setSelectedMapElement,
}: Props) => {
  const { t } = useTranslation('wap');
  const { language } = useContext(ApiContext);

  if (!records?.length) {
    return null;
  }

  const options = records.map((record) => ({
    label: record.name[language],
    value: record.bfs_number,
  }));

  const onSelectMuni = ({ target }: { target: { value: string } }) => {
    const bfsNumber = target.value;

    if (!bfsNumber) {
      setSelectedMapElement(null);
      return;
    }

    if (bfsNumber === selectedMapElement?.bfs_number) {
      return;
    }

    const selectedRecord = records.find((record) => record.bfs_number === bfsNumber);
    if (selectedRecord) {
      setSelectedMapElement(selectedRecord);
    }
  };

  return (
    <SelectInput
      additionalClassNames="proportionalmap__select"
      name="municipality"
      label="municipality"
      clearable
      placeholder={t('municipality_search')}
      options={options}
      onChange={onSelectMuni}
      value={selectedMapElement?.bfs_number}
    />
  );
};

export default ProportionalMapSelect;
